import React from "react";
import { cn } from "@/lib/utils";
import { useContent } from "@/context/ContentContext";

/**
 * Testo modificabile inline. In modalita editor (edit=1 + login) il nodo diventa
 * contentEditable; al blur salva l'override. Fuori dall'editor mostra l'override
 * salvato oppure il contenuto di default (children).
 */
export function Editable({ path, as: Tag = "span", className, children }) {
  const { authed, texts, setText } = useContent();
  const override = texts[path];
  const hasOverride = override !== undefined && override !== null;

  if (authed) {
    return (
      <Tag
        className={cn(
          "cursor-text rounded-sm outline-dashed outline-1 outline-sky-400/70 transition-[outline] focus:outline-2 focus:outline-sky-500",
          className
        )}
        contentEditable
        suppressContentEditableWarning
        spellCheck={false}
        data-editpath={path}
        onBlur={(e) => setText(path, e.currentTarget.innerText)}
      >
        {hasOverride ? override : children}
      </Tag>
    );
  }

  return <Tag className={className}>{hasOverride ? override : children}</Tag>;
}
